(() => {
  'use strict';

  const CTA_PATTERN = /voir le bijou|voir la collection|découvrir|je la veux|acheter/i;

  function textOf(element) {
    return (element?.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function isInternalCommerceLink(anchor) {
    try {
      const url = new URL(anchor.href, window.location.origin);
      return (
        url.origin === window.location.origin &&
        (/^\/products\//.test(url.pathname) || /^\/collections\//.test(url.pathname))
      );
    } catch (_error) {
      return false;
    }
  }

  function removeRatingStars(card) {
    const starIcons = Array.from(card.querySelectorAll('svg')).filter((svg) => {
      const fill = (svg.getAttribute('fill') || '').toLowerCase();
      const path = svg.querySelector('path')?.getAttribute('d') || '';
      return fill === '#f5a623' || path.startsWith('M12 2L15.09 8.26');
    });

    const holders = new Set(starIcons.map((svg) => svg.parentElement).filter(Boolean));
    starIcons.forEach((svg) => svg.remove());
    holders.forEach((holder) => {
      if (!holder.querySelector('svg') && !textOf(holder)) holder.remove();
    });
  }

  function normalizeProductCardTitle(title) {
    if (!/^H[2-4]$/.test(title.tagName)) return title;
    const replacement = document.createElement('p');
    Array.from(title.attributes).forEach((attribute) => replacement.setAttribute(attribute.name, attribute.value));
    while (title.firstChild) replacement.appendChild(title.firstChild);
    title.replaceWith(replacement);
    return replacement;
  }

  function enhanceCard(cta) {
    const card = cta.parentElement;
    if (!card || card.classList.contains('uc-article-product-card')) return card;

    let title = card.querySelector('.uc-article-product-title, h2, h3, h4');
    const image = card.querySelector('img');
    if (!title || !image) return null;
    title = normalizeProductCardTitle(title);

    const mediaLink = Array.from(card.querySelectorAll('a')).find((anchor) => anchor.contains(image));
    if (!mediaLink || !isInternalCommerceLink(mediaLink)) return null;

    card.classList.add('uc-article-product-card');
    card.setAttribute('data-no-toc', 'true');
    title.classList.add('uc-article-product-title', 'no-toc');
    title.setAttribute('data-no-toc', 'true');
    image.classList.add('uc-article-product-image');
    mediaLink.classList.add('uc-article-product-media');
    cta.classList.add('uc-article-product-cta');
    removeRatingStars(card);

    const productName = textOf(title);
    if (productName) {
      if (!image.alt) image.alt = productName;
      mediaLink.setAttribute('aria-label', `Découvrir ${productName}`);
      cta.setAttribute('aria-label', `${textOf(cta) || 'Découvrir'} — ${productName}`);
    }

    return card;
  }

  function enhanceProductCards() {
    const root = document.getElementById('article-content');
    if (!root || root.dataset.ucProductCardsReady === 'true') return;

    const cards = Array.from(root.querySelectorAll('a'))
      .filter((anchor) => CTA_PATTERN.test(textOf(anchor)) && isInternalCommerceLink(anchor))
      .map(enhanceCard)
      .filter(Boolean);

    const parents = new Set(cards.map((card) => card.parentElement).filter(Boolean));
    parents.forEach((parent) => {
      const directCards = cards.filter((card) => card.parentElement === parent);
      if (directCards.length >= 2) parent.classList.add('uc-article-product-grid');
    });

    root.dataset.ucProductCardsReady = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceProductCards, { once: true });
  } else {
    enhanceProductCards();
  }
})();
